<div class="no-instructor">
	<div class="avatar"></div>
	<div class="information"></div>
</div>
